import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54f78787"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-content" }
const _hoisted_2 = { class: "weather" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "weather-text" }
const _hoisted_5 = { class: "pr5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pr5" }, "PM2.5", -1))
const _hoisted_8 = { class: "pr5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("img", {
        src: _ctx.outWeather.imgname,
        class: "weather-icon",
        alt: ""
      }, null, 8, _hoisted_3), [
        [_vShow, _ctx.outWeather.imgname]
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", null, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.outWeather.temperature ? _ctx.outWeather.temperature : "--") + "℃", 1),
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("span", null, _toDisplayString(_ctx.outWeather.pm25 ? _ctx.outWeather.pm25 : "--"), 1)
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.outWeather.text ? _ctx.outWeather.text : "--"), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.outWeather.quality ? _ctx.outWeather.quality : "--"), 1)
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "set-space-btn",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setPermanentSpace && _ctx.setPermanentSpace(...args)))
    }, "设置常驻空间")
  ]))
}